import { c as _c } from "react/compiler-runtime";
import { DropdownMenuItem } from '@achra/ui/dropdown-menu';
import { cn } from '@achra/ui/lib/utils';
import Link from 'next/link';
import type { NavbarLink } from '@/modules/shared/config/navbar-config';
import { isActive } from '@/modules/shared/lib/navbar-utils';
function MobileNavItem(t0) {
  const $ = _c(7);
  const {
    link,
    pathname
  } = t0;
  const isItemActive = isActive(pathname, link.activeWhen ?? link.href);
  const t1 = link.href;
  const t2 = isItemActive ? "text-primary hover:bg-accent hover:text-primary! font-semibold" : "text-foreground hover:bg-accent hover:text-foreground!/50";
  let t3;
  if ($[0] !== t2) {
    t3 = cn("block w-full rounded-sm p-3 text-sm leading-none no-underline transition-colors outline-none select-none", t2);
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = isItemActive ? "page" : undefined;
  let t5;
  if ($[2] !== link.href || $[3] !== link.label || $[4] !== t3 || $[5] !== t4) {
    t5 = <DropdownMenuItem asChild={true} className="p-2"><Link href={t1} className={t3} aria-current={t4}>{link.label}</Link></DropdownMenuItem>;
    $[2] = link.href;
    $[3] = link.label;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}
MobileNavItem.displayName = 'MobileNavItem';
export { MobileNavItem };